<template>
    <div>
        <div class="columns">
            <div class="column">
                <p class="has-text-primary has-text-weight-semibold"> {{$root.selectedLanguageData.nominee}}  {{nomineeIndex+1}} </p>

                       <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si` ? `si-label`: ``}`">
                    {{ $root.selectedLanguageData.nameOfTheNominee}}
                    <span class="has-text-danger">*</span>
                  </label>
                    <b-field>
                      <ValidationProvider name="Nominee Name" :rules="{ required: true, notEndsWith: ' ', notStartsWith: ' ', customerName:true,noNumbers:true }" v-slot="{ errors }">
                        <p class="control has-icons-right">
                          <b-input v-model="$root.formData.nomineesData[nomineeIndex].name " @keyup.native="$emit('nameSetter', $root.formData.nomineesData[nomineeIndex].name)" :disabled="isDisabled">
                          </b-input>
                          <span class="icon is-small is-right">
                            <img src="../../../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                        </p>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>

        </div>

                 <!-- Gender -->
                <div class="field mt-4">
                  <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si` ? `si-label`: ``}`">
                    {{ $root.selectedLanguageData.gender}}
                    <span class="has-text-danger">*</span>
                  </label>

                  <div class="columns">
                    <div class="column is-one-quarter">
                      <b-field>
                        <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                          <b-radio
                              :name="`nomineeGender ${nomineeIndex}`"
                              style="font-family: OpenSans-Regular"
                              native-value="Male"
                              @focus="$inputFocused('nomineeGender')"
                              @blur="$inputBlured('nomineeGender')"
                              v-model="$root.formData.nomineesData[nomineeIndex].gender"
                              @input="
                                $emit('genderSetter', 'Male');
                                genderChecker(nomineeIndex);
                                $emit('nicValidator', invalidGender, sameNic);
                              "
                              :disabled="isDisabled"
                          >
                            {{$root.selectedLanguageData.male }}
                          </b-radio>
                          <span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </b-field>
                    </div>
                    <div class="column is-one-quarter">
                      <b-field>
                        <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                          <b-radio
                              :name="`nomineeGender ${nomineeIndex}`"
                              style="font-family: OpenSans-Regular"
                              native-value="Female"
                              @focus="$inputFocused('nomineeGender')"
                              @blur="$inputBlured('nomineeGender')"
                              v-model="$root.formData.nomineesData[nomineeIndex].gender"
                              @input="
                                $emit('genderSetter', 'Female');
                                genderChecker(nomineeIndex);
                                $emit('nicValidator', invalidGender, sameNic);
                              "
                              :disabled="isDisabled"
                          >
                            {{ $root.selectedLanguageData.female }}
                          </b-radio>
                          <span class="has-text-danger">{{errors[0] }}</span>
                        </ValidationProvider>
                      </b-field>
                    </div>
                  </div>
                </div>

                 <div class="mt-4">
                <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                  {{ $root.selectedLanguageData.curruntResidentialAddress }}
                </label>
                <!--permanent address house name-->
                <div class="mt-1">
                  <p>
                    {{ $root.selectedLanguageData.houseName }}
                    <span class="has-text-danger">*</span>
                  </p>
                  <b-field>
                    <ValidationProvider  name="Nominee address line 1" :rules="{ required: true, regex: /^[a-zA-Z0-9\s/,-]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                      <p class="control has-icons-right">
                        <b-input type="text" @focus="$inputFocused('donor_permanent_address_line1')"
                                 @input="$inputChanged('donor_permanent_address_line1')"
                                 @blur="$inputBlured('donor_permanent_address_line1')"
                                 v-model="$root.formData.nomineesData[nomineeIndex].houseName" @keyup.native="$emit('houseNameSetter', $root.formData.nomineesData[nomineeIndex].houseName)" :disabled="isDisabled"></b-input>
                        <span class="icon is-small is-right">
                            <img src="../../../assets/images/icons/Blue/home.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                      </p>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-field>
                </div>

                <div class="columns is-7 is-variable mt-2">
                  <!--permanent address street name-->
                  <div class="column">
                    <p>
                      {{ $root.selectedLanguageData.streetName }}
                      <span class="has-text-danger">*</span>
                    </p>
                    <b-field>
                      <ValidationProvider  name="Nominee address street name" :rules="{ required: true, regex:/^[a-zA-Z0-9\s/,-]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                        <p class="control has-icons-right">
                          <b-input type="text" @focus="$inputFocused('donor_permanent_address_line2')"
                                   @input="$inputChanged('donor_permanent_address_line2')"
                                   @blur="$inputBlured('donor_permanent_address_line2')"
                                   v-model="$root.formData.nomineesData[nomineeIndex].streetName" @keyup.native="$emit('streetNameSetter', $root.formData.nomineesData[nomineeIndex].streetName)" :disabled="isDisabled"></b-input>
                          <span class="icon is-small is-right">
                              <img src="../../../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                        </p>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                  <!--permanent address city-->
                  <div class="column">
                    <p>
                      {{ $root.selectedLanguageData.city }}
                      <span class="has-text-danger">*</span>
                    </p>
                    <b-field>
                      <ValidationProvider  name="Nominee adress city" :rules="{ required: true, regex: /^[a-zA-Z\s]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                        <p class="control has-icons-right">
                          <b-input type="text" @focus="$inputFocused('donor_permanent_address_line3')"
                                   @input="$inputChanged('donor_permanent_address_line3')"
                                   @blur="$inputBlured('donor_permanent_address_line3')"
                                   v-model="$root.formData.nomineesData[nomineeIndex].city" @keyup.native="$emit('citySetter', $root.formData.nomineesData[nomineeIndex].city)" :disabled="isDisabled"></b-input>
                          <span class="icon is-small is-right">
                              <img src="../../../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                        </p>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                </div>

                <div class="columns is-7 is-variable">
                  <!--permanent address postal code-->
                  <div class="column">
                    <p>{{ $root.selectedLanguageData.postalCode }}</p>
                    <b-field>
                      <ValidationProvider name="Nominee adress postal code"  :rules="{ regex: /^\d{5}$/, notEndsWith: ' ' }" v-slot="{ errors }">
                        <p class="control has-icons-right">
                          <b-input type="text" @focus="$inputFocused('permanent_address_postal_code')"
                                   @input="$inputChanged('permanent_address_postal_code')"
                                   @blur="$inputBlured('permanent_address_postal_code')"
                                   v-model="$root.formData.nomineesData[nomineeIndex].postalCode" @keyup.native="$emit('postalCodeSetter', $root.formData.nomineesData[nomineeIndex].postalCode)" :disabled="isDisabled">
                          </b-input>
                          <span class="icon is-small is-right">
                            <img src="../../../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                        </p>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                  <!--permanent address country-->
                  <div class="column">
                    <p>
                      {{ $root.selectedLanguageData.country }}
                      <span class="has-text-danger">*</span>
                    </p>
                    <div>
                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                        <div style="width: 100%">
                          <b-select @focus="$inputFocused('permanent_address_country')"
                                    @input="$inputChanged('permanent_address_country')"
                                    @blur="$inputBlured('permanent_address_country')"
                                    v-model="$root.formData.nomineesData[nomineeIndex].country" expanded @click.native="$emit('countrySetter', $root.formData.nomineesData[nomineeIndex].country)" :disabled="isDisabled">
                            <option v-for="country in $root.selectedLanguageData
                                .countries" :key="country.value" :value="country.value">
                              {{ country.countryName }}
                            </option>
                          </b-select>
                        </div>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
              </div>

                          <div class="mt-4 columns">
                <div class="column is-one-two">
                  <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.nic_number
  }}<span class="has-text-danger">*</span>
                  </label>
              <b-field>
                  <ValidationProvider name="Nominee NIC Number" :rules="{ required: true,multiRegex: [/^([0-9]{9}[Xx||Vv])$/, /^[0-9]{12}$/],}" v-slot="{ errors }">
                    <b-input
                        v-model="$root.formData.nomineesData[nomineeIndex].nic"
                        @keyup.native="
                          $emit('nicSetter', $root.formData.nomineesData[nomineeIndex].nic);
                          $emit('dobSetter', $root.formData.nomineesData[nomineeIndex].dob);
                          $emit('nicValidator', invalidGender, sameNic)
                        "
                        @input="calculateDateOfBirth(); nicRepeatChecker(); genderChecker(nomineeIndex);"
                        :disabled="isDisabled"
                    ></b-input>
                    <span class="has-text-danger">{{ errors[0] }}</span>
                    <br>
                  </ValidationProvider>
                <span v-if="sameNic === true" class="has-text-danger">Cannot repeat same NIC</span>
                <br v-if="sameNic === true">
                <span v-if="invalidGender === true" class="has-text-danger">NIC does not match with the gender</span>
              </b-field>

                </div>
                <div class="column is-one-two">
                  <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.dateofBirth
  }}<span class="has-text-danger">*</span>
                  </label>

                    <div>
                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                    <b-datepicker
                    :disabled="isDisabled"
                    type="date"
                    placeholder="Click to select..."
                    icon="calendar-today"
                    v-model="$root.formData.nomineesData[nomineeIndex].dob"
                    trap-focus>


                    </b-datepicker>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>

                </div>
              </div>

               <div class="mt-4 columns">
                <div class="column is-one-two">
                  <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.relationship_with_the_acc_holder
  }}<span class="has-text-danger">*</span>
                  </label>
                  <ValidationProvider name="Nominee Relationship" :rules="{ required: true, alpha: true }" v-slot="{ errors }">
                  <b-input  v-model="$root.formData.nomineesData[nomineeIndex].relationship" @keyup.native="$emit('relationshipSetter', $root.formData.nomineesData[nomineeIndex].relationship)" :disabled="isDisabled"></b-input>
                   <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>

                </div>
                <div class="column is-one-two">
                  <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.share
  }}<span class="has-text-danger">*</span>
                  </label>

                    <div>
                      <ValidationProvider name="Nominee Share" :rules="{ required: true, numberRange:[100, 1], }" v-slot="{ errors }">
                   <b-input  v-model="$root.formData.nomineesData[nomineeIndex].share"  @keyup.native="$emit('shareSetter', $root.formData.nomineesData[nomineeIndex].share)" @input="nomineesShareExeedChecker" :disabled="isDisabled"></b-input>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                        <br>
                        <span v-if="$root.formData.isShareOnLimit ===false" class="has-text-danger">Total share should be 100% </span>
                      </ValidationProvider>
                    </div>

                </div>
              </div>



    </div>
</template>

<script>
  import { ValidationProvider } from "vee-validate";
// import { watch } from 'vue';
export default {
    name: 'NomineesInfo',
    // props : ["nomineeName", "nomineeGender", "nomineeNic", "nomineeShare"],
    // props : ['nomineeName'],
    emits : ['nameSetter', 'nicSetter', 'relationshipSetter', 'shareSetter', 'genderSetter', 'houseNameSetter', 'streetNameSetter', 'citySetter', 'postalCodeSetter', 'countrySetter', 'dobSetter', 'nicValidator'],
    props : ['nomineeIndex', 'isDisabled'],
   
    components:{
        
        ValidationProvider,
    },


    data(){
      return{
        houseName : '',
        streetName : '',
        city : '',
        postalCode : '',
        country : '',
        // donorAddress : '',
        nomineeName: '',
        nomineeGender: '',
        nomineeNic: '',
        nomineeShare: '',
        nomineeDob : '',
        invalidGender: false,
        sameNic: false,
      } 
    },

    methods:{

  nicRepeatChecker(){
    if(this.$root.formData.customer_nic === this.$root.formData.nomineesData[0].nic || this.$root.formData.nomineesData[1].nic === this.$root.formData.nomineesData[0].nic || this.$root.formData.customer_nic === this.$root.formData.nomineesData[1].nic){
      this.sameNic = true
    }
    else{
      this.sameNic = false;
    }
  },

  genderChecker(nomineeIndex) {
    const nic = this.$root.formData.nomineesData[nomineeIndex].nic;
    const gender = this.$root.formData.nomineesData[nomineeIndex].gender;

    this.invalidGender = false;

    if (!nic || !gender) return;

    let dayPart = null;

    if (/^\d{9}[VX]$/i.test(nic)) {
      dayPart = parseInt(nic.substring(2, 5));
    }
    else if (/^\d{12}$/.test(nic)) {
      dayPart = parseInt(nic.substring(4, 7));
    } else {
      return null;
    }

    const nicGender = dayPart > 500 ? "Female" : "Male";
    this.invalidGender = nicGender !== gender;
  },

      
nomineesShareExeedChecker(){
  // if(parseInt(this.$root.formData.nomineesData[0].share) + parseInt(this.$root.formData.nomineesData[1].share) + parseInt(this.$root.formData.nomineesData[2].share) > 100){
  //   this.$root.formData.isShareOnLimit = false
    
  // }
  // else {
  //   this.$root.formData.isShareOnLimit = true
  // }
   console.log("isShareOnLimit ", this.$root.formData.isShareOnLimit)
   let totalShare = 0 
    this.$root.formData.nomineesData.forEach(element => {
      // let intShare = parseInt(element.share)
   totalShare = parseFloat(totalShare) + parseFloat(element.share)
  //  console.log("element.share", typeof element.share)
   if(totalShare > 100 || totalShare < 100){
    this.$root.formData.isShareOnLimit = false
   }
     else if(totalShare == 100){
    this.$root.formData.isShareOnLimit = true
   }
   });
   console.log("tottal share", totalShare)

  
  //  console.log("typeof this.$root.formData.nomineesData[1].share ",typeof this.$root.formData.nomineesData[1].share)
},

      // concatDonorAddress(){
      //   this.donorAddress =`${this.houseName
      //   } ${this.houseName ? "," : ""} ${this.streetName
      //   }${this.streetName ? "," : ""}${this.city
      //   }${this.city ? "," : ""} ${this.postalCode
      //   }${this.postalCode ? "," : ""}${this.country
      //   }`;
      // }

calculateDateOfBirth () {
  let year;
  let genderValue;
  let monthAndDayInDays;
 
  // let dateOfBirth;

  if (this.$root.formData.nomineesData[this.nomineeIndex].nic.length === 10) {
    genderValue = this.$root.formData.nomineesData[this.nomineeIndex].nic.slice(2, 5);
    monthAndDayInDays =
      parseInt(genderValue, 10) >= 500
        ? parseInt(genderValue - 500, 10)
        : parseInt(genderValue, 10);
    year = parseInt(`19${this.$root.formData.nomineesData[this.nomineeIndex].nic.slice(0, 2)}`, 10);
  } else if (this.$root.formData.nomineesData[this.nomineeIndex].nic.length === 12) {
    genderValue = this.$root.formData.nomineesData[this.nomineeIndex].nic.slice(4, 7);
    monthAndDayInDays =
      parseInt(genderValue, 10) >= 500
        ? parseInt(genderValue - 500, 10)
        : parseInt(genderValue, 10);
    year = parseInt(`${this.$root.formData.nomineesData[this.nomineeIndex].nic.slice(0, 4)}`, 10);
  }
  let month;
  let day;
  if (monthAndDayInDays <= 31) {
    month = "01";
    if (monthAndDayInDays < 10) {
      day = `0${monthAndDayInDays}`;
    } else {
      day = monthAndDayInDays;
    }
  } else if (monthAndDayInDays <= 60) {
    month = "02";
    day = monthAndDayInDays - 31;
  } else if (monthAndDayInDays <= 91) {
    month = "03";
    day = monthAndDayInDays - 60;
  } else if (monthAndDayInDays <= 121) {
    month = "04";
    day = monthAndDayInDays - 91;
  } else if (monthAndDayInDays <= 152) {
    month = "05";
    day = monthAndDayInDays - 121;
  } else if (monthAndDayInDays <= 182) {
    month = "06";
    day = monthAndDayInDays - 152;
  } else if (monthAndDayInDays <= 213) {
    month = "07";
    day = monthAndDayInDays - 182;
  } else if (monthAndDayInDays <= 244) {
    month = "08";
    day = monthAndDayInDays - 213;
  } else if (monthAndDayInDays <= 274) {
    month = "09";
    day = monthAndDayInDays - 244;
  } else if (monthAndDayInDays <= 305) {
    month = "10";
    day = monthAndDayInDays - 274;
  } else if (monthAndDayInDays <= 335) {
    month = "11";
    day = monthAndDayInDays - 305;
  } else {
    month = "12";
    day = monthAndDayInDays - 335;
  }

  this.$root.formData.nomineesData[this.nomineeIndex].dob =  new Date(year, month-1, day);
  console.log(this.$root.formData.nomineesData[this.nomineeIndex].dob);
  
  //  this.$root.formData.customer_gender = genderValue < 500 ? "Male" : "Female";
},
    },



// watch:{

//   nomineesData: {
//     handler() {
//       this.nomineesShareExeedChecker();
//     },
//       deep: true 
//     },

//       }
}
</script>